import React from "react";
import { Story } from "../../../types";
import AvatarHeader from "../avatar-header/avatar-header";
import { makeNice, SafeJoin } from "../../../util";
import PrevSubmission from "../prev-submission/prev-submission";

type Props = {
  story: Story;
  multiPrompt?: boolean;
};

const CanvasView = ({ story, multiPrompt }: Props) => {
  const titles = [
    <span className={"underline font-bold"}>{story.meta.title}</span>,
    <>
      characters:{" "}
      {SafeJoin(
        story.characters
          ?.filter((c) => c.selected)
          .map<React.ReactNode>((c) => (
            <span className={"italic"} key={"char-" + c.id}>
              {c.name}
            </span>
          )),
        ", "
      )}{" "}
    </>,
  ];

  if (!multiPrompt) {
    titles.push(
      <>
        writers:{" "}
        {makeNice(
          story.submissions.map<React.ReactNode>((s) => (
            <span className={"italic"} key={"player-" + s.id}>
              {s.player.name}
            </span>
          ))
        )}{" "}
      </>
    );
    titles.push(<>Rated {story.settings.mature ? "18+" : "ALL AGES"}</>);
  }

  return (
    <div
      className={
        "h-full w-full -z-10 absolute overflow-y-scroll overflow-x-hidden"
      }
    >
      <div
        id={"canvas-" + story.id}
        className={
          "flex-grow relative flex flex-col items-stretch pb-8 bg-gray-light"
        }
      >
        <AvatarHeader tall titlesJsx={titles} />
        <div className={"relative flex-grow flex flex-col"}>
          <div className={"flex-grow flex flex-col"}>
            {story.submissions.map<React.ReactNode>((s, idx) => {
              return (
                <div key={"canvas-submission-" + s.id}>
                  <div
                    key={s.id}
                    className={
                      "px-4 pt-2 text-base break-words whitespace-pre-wrap normal-case"
                    }
                  >
                    <PrevSubmission variant="read" submission={s} />
                    {(multiPrompt ||
                      s.index === story.submissions.length - 1) &&
                      s.meta.prompt && (
                        <div className={"vote-row-buttons italic mt-2"}>
                          prompt: {s.meta.prompt}
                        </div>
                      )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CanvasView;
